interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "TOP";
};

const TOP: Currency = Object.freeze({
  "displayName": "Tongan Pa’anga",
  "numericCode": 776,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "TOP",
  "symbol": "T$"
});

export { TOP };
